import * as Sentry from "@sentry/browser";
export default class SentryService {
    static logMessage(message: any, action: string = "") {
        if (message) {
            Sentry.captureMessage(
                `Log-Action: ${action}, Message: ${JSON.stringify(message)}`
            );
        }
    }

    static logError(exception: any, action: string = "") {
        if (exception) {
            Sentry.captureException(exception);
        }
    }
    
}